// extracted by css-extract-rspack-plugin
export default {"permit":"Permit_permit__-9a4U","input":"Permit_input__+mIcT","button":"Permit_button__CKch8","locked":"Permit_locked__EHiJa","approved":"Permit_approved__Sr512"};